/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Verify_Signing_InInputs */



/**
* | output |
* | --- |
* | "Signing you in…" |
*
* @param {Verify_Signing_InInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const verify_signing_in = /** @type {((inputs?: Verify_Signing_InInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Verify_Signing_InInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Je wordt aangemeld…")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Connexion en cours…")
	return /** @type {LocalizedString} */ ("Signing you in…")
});